(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CovidFacility', CovidFacility);

    CovidFacility.$inject = ['$resource'];

    function CovidFacility ($resource) {
        var resourceUrl =  'api/covid-facilities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {
                url: 'api/covid-facilities/filter',
                method: 'GET',
                isArray: true
            }
        });
    }
})();
